<template>
  <div class="editControlRange">
    <!--控制范围信息-->
    <el-form
      ref="editControlRange"
      label-position="right"
      label-width="110px"
      :rules="rules"
      :model="detail"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.controlCode')">
            <el-input v-model="detail.controlAreaCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyStatus')">
            <el-input v-model="detail.currentStatusName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.controlName')" prop="controlAreaName">
            <el-input
              v-model="detail.controlAreaName"
              clearable
              :maxlength="64"
              :placeholder="$t('company.controlAreaNamePlaceholder')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyIndex')">
            <el-input-number
              v-model="detail.sortOrder"
              :controls="false"
              class="inputWidth"
              :min="0"
              :max="999"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="department-content">{{ this.$t('company.controlRangeTitle') }}</div>
    <!--新增/删除按钮-->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="deleteEvent()"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-table
      border
      size="mini"
      show-overflow
      show-header-overflow
      ref="xTable"
      class="edit-table"
      :data="tableData"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="controlAreaDepartmentNo"
        :title="$t('company.table.departmentName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <treeselect
            :options="options"
            v-model="scope.row.controlAreaDepartmentNo"
            :defaultExpandLevel="Infinity"
            openDirection="auto"
            :clearable="false"
            :maxHeight="200"
            :zIndex="2999"
            :flat="true"
            :append-to-body="true"
            @select="(val) => selectNode(val, scope)"
            @input="(val) => inputChange(val, scope)"
            :placeholder="$t('company.treeselect.searchIndex')"
            :noResultsText="$t('company.treeselect.noData')"
            :searchPromptText="$t('company.treeselect.searchIndex')"
          />
        </template>
        <template v-slot="{ row }">{{ row.companyDepartmentName }}</template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  // import SiruiTable from '@/components/SiruiTable';
  import { isEqual } from '@/common/js/util';

  export default {
    name: 'editControlRange',
    components: {
      // SiruiTable,
    },
    data() {
      return {
        options: [],
      };
    },
    props: {
      detail: {
        type: Object,
        default: () => {},
      },
      tableData: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      columnList() {
        return [
          {
            prop: 'companyDepartmentName',
            label: this.$t('company.table.departmentName'),
          },
        ];
      },
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value != null && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          controlAreaName: [
            {
              required: true,
              message: this.$t('company.controlAreaNameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 64,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
      validRules() {
        return {
          controlAreaDepartmentNo: [
            { required: true, message: this.$t('company.departmentNameNotEmpty') },
          ],
        };
      },
    },
    methods: {
      initDepartment() {
        if (this.$refs['editControlRange']) {
          this.$refs['editControlRange'].resetFields();
        }
        const query = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
        };
        this.$axios.post(API.LIST_COMPANY_API, query).then((res) => {
          if (0 == res.data.code) {
            this.options = res.data.data;
            this.getSelectedNode(this.options, this.options);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //新增一行
      insertEvent() {
        // const tableList = this.$refs.xTable.getTableData().fullData;
        this.$refs.xTable.validate().then(() => {
          const record = {
            controlAreaDepartmentNo: null,
            companyDepartmentName: null,
            controlAreaCompanyNo: null,
            controlAreaTenantNo: null,
          };
          this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //选中节点
      selectNode(node, scope) {
        this.$axios.get(API.GET_PARENT_UNIT_API + '/' + node.id).then((res) => {
          if (0 == res.data.code) {
            scope.row.companyDepartmentName = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
        scope.row.controlAreaCompanyNo = node.attributes.belongCompanyCode;
        scope.row.controlAreaTenantNo = node.attributes.belongTenantCode;
        this.$refs.xTable.updateStatus(scope);
      },
      //清空之后
      inputChange(value, scope) {
        if (!value) {
          scope.row.companyDepartmentName = null;
          scope.row.controlAreaCompanyNo = null;
          scope.row.controlAreaTenantNo = null;
          this.$refs.xTable.updateStatus(scope);
        }
      },
      //保存
      addSure(load) {
        // let xTableValidFlag = true;
        let status = false;
        //1.校验表格
        this.$refs.xTable.validate().then(() => {
          const tableList = this.$refs.xTable.getTableData().fullData;
          //2.判断是否有重复的数据
          if (tableList.length > 1) {
            let start = 1;
            for (let n = 0; n < tableList.length; n++) {
              if (status) {
                break;
              }
              for (start; start < tableList.length; start++) {
                if (n != start) {
                  status = isEqual(tableList[n], tableList[start], 'controlAreaDepartmentNo');
                  if (status) {
                    break;
                  }
                }
              }
              start = n;
            }
          }
          if (status) {
            this.$message({
              showClose: true,
              message: this.$t('company.departmentSameData'),
              type: 'error',
            });
            return;
          }
          this.$refs['editControlRange'].validate((valid) => {
            if (valid && !load) {
              this.$emit('setLoading', { loading: true });
              this.detail.controlAreaDepartmentStr =
                tableList.length == 0 ? null : JSON.stringify(tableList);
              this.$axios.post(API.UPDATE_CONTROLAREA_API, this.detail).then((res) => {
                this.$emit('setLoading', { loading: false, edit: false });
                if (0 != res.data.code) {
                  this.$alert(res.data.msg);
                } else {
                  this.$emit('getData');
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                }
              });
            } else {
              return false;
            }
          });
        });
        // this.$refs.xTable.validate(xTableValid => {
        //   xTableValidFlag = xTableValid;
        //   if (xTableValid) {
        //     const tableList = this.$refs.xTable.getTableData().fullData;
        //     //2.判断是否有重复的数据
        //     if (tableList.length > 1) {
        //       let start = 1;
        //       for (let n = 0; n < tableList.length; n++) {
        //         if (status) {
        //           break;
        //         }
        //         for (start; start < tableList.length; start++) {
        //           if (n != start) {
        //             status = isEqual(
        //               tableList[n],
        //               tableList[start],
        //               "controlAreaDepartmentNo"
        //             );
        //             if(status){
        //               break;
        //             }
        //           }
        //         }
        //         start = n;
        //       }
        //     }
        //     if (status) {
        //       this.$message({
        //         showClose: true,
        //         message: this.$t("company.departmentSameData"),
        //         type: "error"
        //       });
        //       return;
        //     }
        //     this.$refs["editControlRange"].validate(valid => {
        //       if (valid && !load) {
        //         this.$emit("setLoading", { loading: true });
        //         this.detail.controlAreaDepartmentStr =
        //           tableList.length == 0 ? null : JSON.stringify(tableList);
        //         this.$axios
        //           .post(API.UPDATE_CONTROLAREA_API, this.detail)
        //           .then(res => {
        //             this.$emit("setLoading", { loading: false, edit: false });
        //             if (0 != res.data.code) {
        //               this.$alert(res.data.msg);
        //             } else {
        //               this.$emit("getData");
        //               this.$message({
        //                 showClose: true,
        //                 message: res.data.msg || this.$t("message.success"),
        //                 type: "success"
        //               });
        //             }
        //           });
        //       } else {
        //         return false;
        //       }
        //     });
        //   }
        // });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
